var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 46,
    viewBox: "0 0 33 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4432 32.7791L31.4426 32.7784L28.2155 28.7435C27.9157 28.3174 27.7388 27.8355 27.7388 27.2952V18.9618C27.7388 13.7424 24.3261 9.0967 19.3788 7.6313V4.47466C19.3788 2.5967 17.8547 1.11953 16.0621 1.11953C14.2676 1.11953 12.7455 2.66276 12.7455 4.47466V7.56816C7.73701 9.0954 4.32217 13.7405 4.38547 18.9628V27.2952C4.38547 27.8355 4.20858 28.3174 3.90881 28.7435L0.681659 32.7784L0.681123 32.7791C0.410782 33.1211 0.205469 33.6017 0.205469 34.09V39.1541V39.3041H0.355469H31.8955H32.0455V39.1541V34.09V34.0693L32.0398 34.0493C31.9105 33.5912 31.7137 33.1214 31.4432 32.7791ZM14.8188 4.62466H14.8821V4.47466C14.8821 3.85066 15.3867 3.34261 15.9988 3.34261C16.6109 3.34261 17.1155 3.85066 17.1155 4.47466V7.18751C16.3359 7.08833 15.5983 7.08833 14.8188 7.18751V4.62466ZM2.2788 37.017V34.1427L5.4746 30.1469C5.47483 30.1466 5.47507 30.1464 5.4753 30.1461C6.1324 29.3476 6.4588 28.3517 6.4588 27.2952V18.9618C6.4588 13.6577 10.7006 9.30415 15.9988 9.30415C21.2976 9.30415 25.5388 13.5943 25.5388 18.9618V27.2952C25.5388 28.3517 25.8652 29.3476 26.5223 30.1461C26.5225 30.1464 26.5228 30.1466 26.523 30.1469L29.7188 34.1427V37.017H2.2788Z",
    fill: "#5956E9",
    stroke: "#5956E9",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 11.184H14.5805V11.334V13.2571V13.4071H14.7305C18.5093 13.4071 21.6105 16.5433 21.6105 20.3724V20.5224H21.7605H23.6605H23.8105V20.3724C23.8105 15.2913 19.755 11.184 14.7305 11.184Z",
    fill: "#5956E9",
    stroke: "#5956E9",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8547 39.4746V39.3246H12.7047H10.8047H10.6547V39.4746C10.6547 42.4404 13.0635 44.881 15.998 44.881C18.9326 44.881 21.3414 42.4404 21.3414 39.4746V39.3246H21.1914H19.2914H19.1414V39.4746C19.1414 41.2525 17.7501 42.6579 15.998 42.6579C14.2459 42.6579 12.8547 41.2525 12.8547 39.4746Z",
    fill: "#5956E9",
    stroke: "#5956E9",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4157cc3041ad7b2f03cc6c8cf92f830b.svg";
export { ForwardRef as ReactComponent };